import { atom } from 'recoil';

interface BreadcrumbHeaderData {
  root: {
    router: string;
    label: string;
  };
  data: Array<{ router: string; label: string }>;
}

export const breadcrumbHeader = atom<BreadcrumbHeaderData>({
  key: 'breadcrumbHeader',
  default: {
    root: {
      router: '/',
      label: 'Dashboard',
    },
    data: [],
  },
});
